export const TOAST_OPTIONS: object = {
  position: 'bottom-center',
  duration: 1500,
};
